import React from 'react';

export default function BscBanner({ text, href = "/category/book-song-challenge" }) {
  return (
    <div className="bsc-banner">
      <a href={href} style={{textDecoration: 'none'}}>
        <div className="bsc-banner-content">
          <p>{text}</p>
        </div>
      </a>
    </div>
  );
}
